/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BulkUpdateRequestDto } from '../models';
// @ts-ignore
import type { BulkUpdateResultDto } from '../models';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { CreateQuestionRequestDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { QuestionDetailsDto } from '../models';
// @ts-ignore
import type { QuestionHistoryDto } from '../models';
// @ts-ignore
import type { QuestionPageDto } from '../models';
// @ts-ignore
import type { QuestionPurposeDto } from '../models';
// @ts-ignore
import type { QuestionTypeDto } from '../models';
// @ts-ignore
import type { QuestionVersionContentDto } from '../models';
// @ts-ignore
import type { QuestionVersionDto } from '../models';
// @ts-ignore
import type { SourceTypeDto } from '../models';
// @ts-ignore
import type { TranslationStatusDto } from '../models';
// @ts-ignore
import type { UpdateClassificationRequestDto } from '../models';
// @ts-ignore
import type { VersionStatusDto } from '../models';
/**
 * QuestionsApi - axios parameter creator
 * @export
 */
export const QuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Exactly one version per question is ACTIVE. Activating a version retires the one in force, in the same transaction, so the question is never left without one in between; the database enforces the rule with a partial unique index. The version\'s wording in its source language is approved with it, if it was still a draft: whoever puts a version in force has read it, and a test draws approved wording only. Other languages keep their status. The history records both in one entry.
         * @summary Make a version the one in force
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateQuestionVersion: async (questionId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('activateQuestionVersion', 'questionId', questionId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('activateQuestionVersion', 'versionId', versionId)
            const localVarPath = `/api/v1/questions/{questionId}/versions/{versionId}/activate`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One operation on many questions: add or remove tags, set the category, retire, mark for review or take the mark off. The questions are named by id — those ticked on the page — or by the list\'s filter, which spares sending thousands of ids and cannot drift from what the list showed; exactly one of the two. Start with dryRun: it answers how many questions the operation changes and a few of their keys, and changes nothing — the confirmation screen is built from it. Above 50 changed questions the request has to say confirmLargeChange, or it is refused with 409: a mistaken click must not retire half the bank. Everything happens in one transaction; on any error nothing changes. A question the operation would leave as it is — already tagged, already in the category, already marked, no version in force to retire — is skipped and counted, not refused. Every question changed gets its own entry in its history. Changing classification creates no version.
         * @summary Change many questions at once
         * @param {BulkUpdateRequestDto} bulkUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateQuestions: async (bulkUpdateRequestDto: BulkUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateRequestDto' is not null or undefined
            assertParamExists('bulkUpdateQuestions', 'bulkUpdateRequestDto', bulkUpdateRequestDto)
            const localVarPath = `/api/v1/questions/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The first version is created as a DRAFT. Leave businessKey empty to have one issued from the category prefix and a counter; supply it only when carrying a question over from an existing bank. A key is unique regardless of letter case: with BHP-1 in the bank, bhp-1 is refused with 409.
         * @summary Create a question with its first version
         * @param {CreateQuestionRequestDto} createQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestion: async (createQuestionRequestDto: CreateQuestionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createQuestionRequestDto' is not null or undefined
            assertParamExists('createQuestion', 'createQuestionRequestDto', createQuestionRequestDto)
            const localVarPath = `/api/v1/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a substantive rewrite. The version in force is retired at once — or, with keepCurrent, stays in force until the new one is activated, so that the question does not drop out of tests while the new version is being prepared. Every translation of the new version except the source language starts as MISSING — which is how the list of questions awaiting translation writes itself. The new version takes over the pictures and films of the newest one, and those of every answer it names by id.
         * @summary Create a new version of a question
         * @param {string} questionId 
         * @param {QuestionVersionContentDto} questionVersionContentDto 
         * @param {boolean} [keepCurrent] true keeps the version in force until the new one is activated; false retires it at once. The interface asks every time — a procedure that changed wants the old wording gone now, a better picture does not.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionVersion: async (questionId: string, questionVersionContentDto: QuestionVersionContentDto, keepCurrent?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('createQuestionVersion', 'questionId', questionId)
            // verify required parameter 'questionVersionContentDto' is not null or undefined
            assertParamExists('createQuestionVersion', 'questionVersionContentDto', questionVersionContentDto)
            const localVarPath = `/api/v1/questions/{questionId}/versions`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keepCurrent !== undefined) {
                localVarQueryParameter['keepCurrent'] = keepCurrent;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionVersionContentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the classification and the full history: every version with its status, scoring and translations. Retired versions are included — an attempt from years ago has to be reproducible in the wording the employee actually saw.
         * @summary One question with every version
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestion: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('getQuestion', 'questionId', questionId)
            const localVarPath = `/api/v1/questions/{questionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Versions newest first, each with its events newest first, and apart from them the changes of the question\'s classification. Answers the question asked at the first dispute about a result: how was this worded when the employee answered, and who has changed it since.
         * @summary What happened to a question, version by version
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionHistory: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('getQuestionHistory', 'questionId', questionId)
            const localVarPath = `/api/v1/questions/{questionId}/history`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any version, a retired one included, exactly as it was worded while it was in force — an attempt from years ago has to be reproducible in the words the employee read. Comparing two versions is left to the interface: it fetches both in full, because what a difference should show changes more often than this contract.
         * @summary One version in full
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionVersion: async (questionId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('getQuestionVersion', 'questionId', questionId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getQuestionVersion', 'versionId', versionId)
            const localVarPath = `/api/v1/questions/{questionId}/versions/{versionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Filtering, sorting and paging happen on the server. The bank is designed for tens of thousands of questions, so fetching everything and filtering in the browser is not an option at any size. Each row describes the version in force, or the newest when none is: what employees see. Filters and the text search read that version too; a draft being written next to it shows as draftVersionNo.
         * @summary List questions
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {QuestionPurposeDto} [purpose] 
         * @param {VersionStatusDto} [status] 
         * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
         * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
         * @param {string} [positionCode] Narrows to questions assigned this position by its number. Questions meant for every position are not among them; allPositions finds those.
         * @param {string} [locale] Language the full text search runs in, and of the summary where the version has wording in it; otherwise the summary is in the source language. Defaults to pl. A tag of a real language, such as pl or pt-BR: xx has the shape but names no language and is refused.
         * @param {TranslationStatusDto} [translationStatus] Finds questions whose translation into \&quot;locale\&quot; is in this state.
         * @param {string} [author] Who created the question, matched exactly. Stored as the sign-in name rather than an id, because authors come from the identity provider and are not a table here.
         * @param {string} [q] Searches the question key, and the question body and its answers in \&quot;locale\&quot;, by fragment: \&quot;olej\&quot; finds \&quot;oleju\&quot;, \&quot;bhp-1\&quot; finds BHP-12. Polish inflects every ending, and PostgreSQL ships no Polish dictionary, so matching whole words would miss most of what people type. At least three characters: the search index works on three-letter fragments, and anything shorter would read every question in the bank. Leave the parameter out to list without searching.
         * @param {string} [changedFrom] 
         * @param {string} [changedTo] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, for example \&quot;updatedAt,desc\&quot;. Defaults to newest change first.
         * @param {boolean} [forReview] true for the questions marked for review, false for the rest. Leave it out for both. Listed last on purpose: generated clients pass parameters by position, and one added in the middle would shift every argument after it.
         * @param {string} [procedureName] Narrows to questions citing this procedure: the name exactly as listProcedureNames gives it, letter case aside. Where a review after the procedure changes starts. After forReview for the reason given there.
         * @param {boolean} [allPositions] true for the questions meant for every position, false for those assigned particular ones. Leave it out for both. Last, for the reason given at forReview.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestions: async (categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, page?: number, size?: number, sort?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (purpose !== undefined) {
                localVarQueryParameter['purpose'] = purpose;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (tagId) {
                localVarQueryParameter['tagId'] = tagId.join(COLLECTION_FORMATS.csv);
            }

            if (positionCode !== undefined) {
                localVarQueryParameter['positionCode'] = positionCode;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (translationStatus !== undefined) {
                localVarQueryParameter['translationStatus'] = translationStatus;
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (changedFrom !== undefined) {
                localVarQueryParameter['changedFrom'] = (changedFrom as any instanceof Date) ?
                    (changedFrom as any).toISOString().substring(0,10) :
                    changedFrom;
            }

            if (changedTo !== undefined) {
                localVarQueryParameter['changedTo'] = (changedTo as any instanceof Date) ?
                    (changedTo as any).toISOString().substring(0,10) :
                    changedTo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (forReview !== undefined) {
                localVarQueryParameter['forReview'] = forReview;
            }

            if (procedureName !== undefined) {
                localVarQueryParameter['procedureName'] = procedureName;
            }

            if (allPositions !== undefined) {
                localVarQueryParameter['allPositions'] = allPositions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Classification hangs off the question, not off a version, so changing it does not create a new version and does not touch what anyone answered. The business key never changes, even when the question moves to a different category — a key is an identifier, not a label. The sources are replaced as a whole, in the order given.
         * @summary Change category, sources, tags and positions
         * @param {string} questionId 
         * @param {UpdateClassificationRequestDto} updateClassificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionClassification: async (questionId: string, updateClassificationRequestDto: UpdateClassificationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('updateQuestionClassification', 'questionId', questionId)
            // verify required parameter 'updateClassificationRequestDto' is not null or undefined
            assertParamExists('updateQuestionClassification', 'updateClassificationRequestDto', updateClassificationRequestDto)
            const localVarPath = `/api/v1/questions/{questionId}/classification`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClassificationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a typo or a clarification that does not change the meaning. Translation statuses are left alone, because the translations still say the same thing; a language the correction adds is a DRAFT. The source language stays as it is — wording first written in another language is a new version, so a different sourceLocale is refused with 400. Retired versions cannot be edited: history that can be corrected is not history. Name every answer that stays by its id: an answer left out is removed with its pictures and films, which a version in force refuses with 409.
         * @summary Correct a version in place
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {QuestionVersionContentDto} questionVersionContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionVersion: async (questionId: string, versionId: string, questionVersionContentDto: QuestionVersionContentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('updateQuestionVersion', 'questionId', questionId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('updateQuestionVersion', 'versionId', versionId)
            // verify required parameter 'questionVersionContentDto' is not null or undefined
            assertParamExists('updateQuestionVersion', 'questionVersionContentDto', questionVersionContentDto)
            const localVarPath = `/api/v1/questions/{questionId}/versions/{versionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionVersionContentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionsApi - functional programming interface
 * @export
 */
export const QuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Exactly one version per question is ACTIVE. Activating a version retires the one in force, in the same transaction, so the question is never left without one in between; the database enforces the rule with a partial unique index. The version\'s wording in its source language is approved with it, if it was still a draft: whoever puts a version in force has read it, and a test draws approved wording only. Other languages keep their status. The history records both in one entry.
         * @summary Make a version the one in force
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateQuestionVersion(questionId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateQuestionVersion(questionId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.activateQuestionVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One operation on many questions: add or remove tags, set the category, retire, mark for review or take the mark off. The questions are named by id — those ticked on the page — or by the list\'s filter, which spares sending thousands of ids and cannot drift from what the list showed; exactly one of the two. Start with dryRun: it answers how many questions the operation changes and a few of their keys, and changes nothing — the confirmation screen is built from it. Above 50 changed questions the request has to say confirmLargeChange, or it is refused with 409: a mistaken click must not retire half the bank. Everything happens in one transaction; on any error nothing changes. A question the operation would leave as it is — already tagged, already in the category, already marked, no version in force to retire — is skipped and counted, not refused. Every question changed gets its own entry in its history. Changing classification creates no version.
         * @summary Change many questions at once
         * @param {BulkUpdateRequestDto} bulkUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateQuestions(bulkUpdateRequestDto: BulkUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpdateResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateQuestions(bulkUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.bulkUpdateQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The first version is created as a DRAFT. Leave businessKey empty to have one issued from the category prefix and a counter; supply it only when carrying a question over from an existing bank. A key is unique regardless of letter case: with BHP-1 in the bank, bhp-1 is refused with 409.
         * @summary Create a question with its first version
         * @param {CreateQuestionRequestDto} createQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestion(createQuestionRequestDto: CreateQuestionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestion(createQuestionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For a substantive rewrite. The version in force is retired at once — or, with keepCurrent, stays in force until the new one is activated, so that the question does not drop out of tests while the new version is being prepared. Every translation of the new version except the source language starts as MISSING — which is how the list of questions awaiting translation writes itself. The new version takes over the pictures and films of the newest one, and those of every answer it names by id.
         * @summary Create a new version of a question
         * @param {string} questionId 
         * @param {QuestionVersionContentDto} questionVersionContentDto 
         * @param {boolean} [keepCurrent] true keeps the version in force until the new one is activated; false retires it at once. The interface asks every time — a procedure that changed wants the old wording gone now, a better picture does not.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestionVersion(questionId: string, questionVersionContentDto: QuestionVersionContentDto, keepCurrent?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestionVersion(questionId, questionVersionContentDto, keepCurrent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestionVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the classification and the full history: every version with its status, scoring and translations. Retired versions are included — an attempt from years ago has to be reproducible in the wording the employee actually saw.
         * @summary One question with every version
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestion(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestion(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Versions newest first, each with its events newest first, and apart from them the changes of the question\'s classification. Answers the question asked at the first dispute about a result: how was this worded when the employee answered, and who has changed it since.
         * @summary What happened to a question, version by version
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionHistory(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionHistory(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Any version, a retired one included, exactly as it was worded while it was in force — an attempt from years ago has to be reproducible in the words the employee read. Comparing two versions is left to the interface: it fetches both in full, because what a difference should show changes more often than this contract.
         * @summary One version in full
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionVersion(questionId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionVersion(questionId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Filtering, sorting and paging happen on the server. The bank is designed for tens of thousands of questions, so fetching everything and filtering in the browser is not an option at any size. Each row describes the version in force, or the newest when none is: what employees see. Filters and the text search read that version too; a draft being written next to it shows as draftVersionNo.
         * @summary List questions
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {QuestionPurposeDto} [purpose] 
         * @param {VersionStatusDto} [status] 
         * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
         * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
         * @param {string} [positionCode] Narrows to questions assigned this position by its number. Questions meant for every position are not among them; allPositions finds those.
         * @param {string} [locale] Language the full text search runs in, and of the summary where the version has wording in it; otherwise the summary is in the source language. Defaults to pl. A tag of a real language, such as pl or pt-BR: xx has the shape but names no language and is refused.
         * @param {TranslationStatusDto} [translationStatus] Finds questions whose translation into \&quot;locale\&quot; is in this state.
         * @param {string} [author] Who created the question, matched exactly. Stored as the sign-in name rather than an id, because authors come from the identity provider and are not a table here.
         * @param {string} [q] Searches the question key, and the question body and its answers in \&quot;locale\&quot;, by fragment: \&quot;olej\&quot; finds \&quot;oleju\&quot;, \&quot;bhp-1\&quot; finds BHP-12. Polish inflects every ending, and PostgreSQL ships no Polish dictionary, so matching whole words would miss most of what people type. At least three characters: the search index works on three-letter fragments, and anything shorter would read every question in the bank. Leave the parameter out to list without searching.
         * @param {string} [changedFrom] 
         * @param {string} [changedTo] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, for example \&quot;updatedAt,desc\&quot;. Defaults to newest change first.
         * @param {boolean} [forReview] true for the questions marked for review, false for the rest. Leave it out for both. Listed last on purpose: generated clients pass parameters by position, and one added in the middle would shift every argument after it.
         * @param {string} [procedureName] Narrows to questions citing this procedure: the name exactly as listProcedureNames gives it, letter case aside. Where a review after the procedure changes starts. After forReview for the reason given there.
         * @param {boolean} [allPositions] true for the questions meant for every position, false for those assigned particular ones. Leave it out for both. Last, for the reason given at forReview.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQuestions(categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, page?: number, size?: number, sort?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQuestions(categoryId, type, purpose, status, source, tagId, positionCode, locale, translationStatus, author, q, changedFrom, changedTo, page, size, sort, forReview, procedureName, allPositions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.listQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Classification hangs off the question, not off a version, so changing it does not create a new version and does not touch what anyone answered. The business key never changes, even when the question moves to a different category — a key is an identifier, not a label. The sources are replaced as a whole, in the order given.
         * @summary Change category, sources, tags and positions
         * @param {string} questionId 
         * @param {UpdateClassificationRequestDto} updateClassificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestionClassification(questionId: string, updateClassificationRequestDto: UpdateClassificationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestionClassification(questionId, updateClassificationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.updateQuestionClassification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For a typo or a clarification that does not change the meaning. Translation statuses are left alone, because the translations still say the same thing; a language the correction adds is a DRAFT. The source language stays as it is — wording first written in another language is a new version, so a different sourceLocale is refused with 400. Retired versions cannot be edited: history that can be corrected is not history. Name every answer that stays by its id: an answer left out is removed with its pictures and films, which a version in force refuses with 409.
         * @summary Correct a version in place
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {QuestionVersionContentDto} questionVersionContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestionVersion(questionId: string, versionId: string, questionVersionContentDto: QuestionVersionContentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestionVersion(questionId, versionId, questionVersionContentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.updateQuestionVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionsApi - factory interface
 * @export
 */
export const QuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionsApiFp(configuration)
    return {
        /**
         * Exactly one version per question is ACTIVE. Activating a version retires the one in force, in the same transaction, so the question is never left without one in between; the database enforces the rule with a partial unique index. The version\'s wording in its source language is approved with it, if it was still a draft: whoever puts a version in force has read it, and a test draws approved wording only. Other languages keep their status. The history records both in one entry.
         * @summary Make a version the one in force
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateQuestionVersion(questionId: string, versionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionVersionDto> {
            return localVarFp.activateQuestionVersion(questionId, versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * One operation on many questions: add or remove tags, set the category, retire, mark for review or take the mark off. The questions are named by id — those ticked on the page — or by the list\'s filter, which spares sending thousands of ids and cannot drift from what the list showed; exactly one of the two. Start with dryRun: it answers how many questions the operation changes and a few of their keys, and changes nothing — the confirmation screen is built from it. Above 50 changed questions the request has to say confirmLargeChange, or it is refused with 409: a mistaken click must not retire half the bank. Everything happens in one transaction; on any error nothing changes. A question the operation would leave as it is — already tagged, already in the category, already marked, no version in force to retire — is skipped and counted, not refused. Every question changed gets its own entry in its history. Changing classification creates no version.
         * @summary Change many questions at once
         * @param {BulkUpdateRequestDto} bulkUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateQuestions(bulkUpdateRequestDto: BulkUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BulkUpdateResultDto> {
            return localVarFp.bulkUpdateQuestions(bulkUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The first version is created as a DRAFT. Leave businessKey empty to have one issued from the category prefix and a counter; supply it only when carrying a question over from an existing bank. A key is unique regardless of letter case: with BHP-1 in the bank, bhp-1 is refused with 409.
         * @summary Create a question with its first version
         * @param {CreateQuestionRequestDto} createQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestion(createQuestionRequestDto: CreateQuestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsDto> {
            return localVarFp.createQuestion(createQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * For a substantive rewrite. The version in force is retired at once — or, with keepCurrent, stays in force until the new one is activated, so that the question does not drop out of tests while the new version is being prepared. Every translation of the new version except the source language starts as MISSING — which is how the list of questions awaiting translation writes itself. The new version takes over the pictures and films of the newest one, and those of every answer it names by id.
         * @summary Create a new version of a question
         * @param {string} questionId 
         * @param {QuestionVersionContentDto} questionVersionContentDto 
         * @param {boolean} [keepCurrent] true keeps the version in force until the new one is activated; false retires it at once. The interface asks every time — a procedure that changed wants the old wording gone now, a better picture does not.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionVersion(questionId: string, questionVersionContentDto: QuestionVersionContentDto, keepCurrent?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<QuestionVersionDto> {
            return localVarFp.createQuestionVersion(questionId, questionVersionContentDto, keepCurrent, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the classification and the full history: every version with its status, scoring and translations. Retired versions are included — an attempt from years ago has to be reproducible in the wording the employee actually saw.
         * @summary One question with every version
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestion(questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsDto> {
            return localVarFp.getQuestion(questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Versions newest first, each with its events newest first, and apart from them the changes of the question\'s classification. Answers the question asked at the first dispute about a result: how was this worded when the employee answered, and who has changed it since.
         * @summary What happened to a question, version by version
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionHistory(questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionHistoryDto> {
            return localVarFp.getQuestionHistory(questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any version, a retired one included, exactly as it was worded while it was in force — an attempt from years ago has to be reproducible in the words the employee read. Comparing two versions is left to the interface: it fetches both in full, because what a difference should show changes more often than this contract.
         * @summary One version in full
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionVersion(questionId: string, versionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionVersionDto> {
            return localVarFp.getQuestionVersion(questionId, versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Filtering, sorting and paging happen on the server. The bank is designed for tens of thousands of questions, so fetching everything and filtering in the browser is not an option at any size. Each row describes the version in force, or the newest when none is: what employees see. Filters and the text search read that version too; a draft being written next to it shows as draftVersionNo.
         * @summary List questions
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {QuestionPurposeDto} [purpose] 
         * @param {VersionStatusDto} [status] 
         * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
         * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
         * @param {string} [positionCode] Narrows to questions assigned this position by its number. Questions meant for every position are not among them; allPositions finds those.
         * @param {string} [locale] Language the full text search runs in, and of the summary where the version has wording in it; otherwise the summary is in the source language. Defaults to pl. A tag of a real language, such as pl or pt-BR: xx has the shape but names no language and is refused.
         * @param {TranslationStatusDto} [translationStatus] Finds questions whose translation into \&quot;locale\&quot; is in this state.
         * @param {string} [author] Who created the question, matched exactly. Stored as the sign-in name rather than an id, because authors come from the identity provider and are not a table here.
         * @param {string} [q] Searches the question key, and the question body and its answers in \&quot;locale\&quot;, by fragment: \&quot;olej\&quot; finds \&quot;oleju\&quot;, \&quot;bhp-1\&quot; finds BHP-12. Polish inflects every ending, and PostgreSQL ships no Polish dictionary, so matching whole words would miss most of what people type. At least three characters: the search index works on three-letter fragments, and anything shorter would read every question in the bank. Leave the parameter out to list without searching.
         * @param {string} [changedFrom] 
         * @param {string} [changedTo] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction, for example \&quot;updatedAt,desc\&quot;. Defaults to newest change first.
         * @param {boolean} [forReview] true for the questions marked for review, false for the rest. Leave it out for both. Listed last on purpose: generated clients pass parameters by position, and one added in the middle would shift every argument after it.
         * @param {string} [procedureName] Narrows to questions citing this procedure: the name exactly as listProcedureNames gives it, letter case aside. Where a review after the procedure changes starts. After forReview for the reason given there.
         * @param {boolean} [allPositions] true for the questions meant for every position, false for those assigned particular ones. Leave it out for both. Last, for the reason given at forReview.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestions(categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, page?: number, size?: number, sort?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<QuestionPageDto> {
            return localVarFp.listQuestions(categoryId, type, purpose, status, source, tagId, positionCode, locale, translationStatus, author, q, changedFrom, changedTo, page, size, sort, forReview, procedureName, allPositions, options).then((request) => request(axios, basePath));
        },
        /**
         * Classification hangs off the question, not off a version, so changing it does not create a new version and does not touch what anyone answered. The business key never changes, even when the question moves to a different category — a key is an identifier, not a label. The sources are replaced as a whole, in the order given.
         * @summary Change category, sources, tags and positions
         * @param {string} questionId 
         * @param {UpdateClassificationRequestDto} updateClassificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionClassification(questionId: string, updateClassificationRequestDto: UpdateClassificationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsDto> {
            return localVarFp.updateQuestionClassification(questionId, updateClassificationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * For a typo or a clarification that does not change the meaning. Translation statuses are left alone, because the translations still say the same thing; a language the correction adds is a DRAFT. The source language stays as it is — wording first written in another language is a new version, so a different sourceLocale is refused with 400. Retired versions cannot be edited: history that can be corrected is not history. Name every answer that stays by its id: an answer left out is removed with its pictures and films, which a version in force refuses with 409.
         * @summary Correct a version in place
         * @param {string} questionId 
         * @param {string} versionId 
         * @param {QuestionVersionContentDto} questionVersionContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionVersion(questionId: string, versionId: string, questionVersionContentDto: QuestionVersionContentDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionVersionDto> {
            return localVarFp.updateQuestionVersion(questionId, versionId, questionVersionContentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionsApi - interface
 * @export
 * @interface QuestionsApi
 */
export interface QuestionsApiInterface {
    /**
     * Exactly one version per question is ACTIVE. Activating a version retires the one in force, in the same transaction, so the question is never left without one in between; the database enforces the rule with a partial unique index. The version\'s wording in its source language is approved with it, if it was still a draft: whoever puts a version in force has read it, and a test draws approved wording only. Other languages keep their status. The history records both in one entry.
     * @summary Make a version the one in force
     * @param {string} questionId 
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    activateQuestionVersion(questionId: string, versionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionVersionDto>;

    /**
     * One operation on many questions: add or remove tags, set the category, retire, mark for review or take the mark off. The questions are named by id — those ticked on the page — or by the list\'s filter, which spares sending thousands of ids and cannot drift from what the list showed; exactly one of the two. Start with dryRun: it answers how many questions the operation changes and a few of their keys, and changes nothing — the confirmation screen is built from it. Above 50 changed questions the request has to say confirmLargeChange, or it is refused with 409: a mistaken click must not retire half the bank. Everything happens in one transaction; on any error nothing changes. A question the operation would leave as it is — already tagged, already in the category, already marked, no version in force to retire — is skipped and counted, not refused. Every question changed gets its own entry in its history. Changing classification creates no version.
     * @summary Change many questions at once
     * @param {BulkUpdateRequestDto} bulkUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    bulkUpdateQuestions(bulkUpdateRequestDto: BulkUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BulkUpdateResultDto>;

    /**
     * The first version is created as a DRAFT. Leave businessKey empty to have one issued from the category prefix and a counter; supply it only when carrying a question over from an existing bank. A key is unique regardless of letter case: with BHP-1 in the bank, bhp-1 is refused with 409.
     * @summary Create a question with its first version
     * @param {CreateQuestionRequestDto} createQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    createQuestion(createQuestionRequestDto: CreateQuestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsDto>;

    /**
     * For a substantive rewrite. The version in force is retired at once — or, with keepCurrent, stays in force until the new one is activated, so that the question does not drop out of tests while the new version is being prepared. Every translation of the new version except the source language starts as MISSING — which is how the list of questions awaiting translation writes itself. The new version takes over the pictures and films of the newest one, and those of every answer it names by id.
     * @summary Create a new version of a question
     * @param {string} questionId 
     * @param {QuestionVersionContentDto} questionVersionContentDto 
     * @param {boolean} [keepCurrent] true keeps the version in force until the new one is activated; false retires it at once. The interface asks every time — a procedure that changed wants the old wording gone now, a better picture does not.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    createQuestionVersion(questionId: string, questionVersionContentDto: QuestionVersionContentDto, keepCurrent?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<QuestionVersionDto>;

    /**
     * Returns the classification and the full history: every version with its status, scoring and translations. Retired versions are included — an attempt from years ago has to be reproducible in the wording the employee actually saw.
     * @summary One question with every version
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    getQuestion(questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsDto>;

    /**
     * Versions newest first, each with its events newest first, and apart from them the changes of the question\'s classification. Answers the question asked at the first dispute about a result: how was this worded when the employee answered, and who has changed it since.
     * @summary What happened to a question, version by version
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    getQuestionHistory(questionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionHistoryDto>;

    /**
     * Any version, a retired one included, exactly as it was worded while it was in force — an attempt from years ago has to be reproducible in the words the employee read. Comparing two versions is left to the interface: it fetches both in full, because what a difference should show changes more often than this contract.
     * @summary One version in full
     * @param {string} questionId 
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    getQuestionVersion(questionId: string, versionId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionVersionDto>;

    /**
     * Filtering, sorting and paging happen on the server. The bank is designed for tens of thousands of questions, so fetching everything and filtering in the browser is not an option at any size. Each row describes the version in force, or the newest when none is: what employees see. Filters and the text search read that version too; a draft being written next to it shows as draftVersionNo.
     * @summary List questions
     * @param {string} [categoryId] 
     * @param {QuestionTypeDto} [type] 
     * @param {QuestionPurposeDto} [purpose] 
     * @param {VersionStatusDto} [status] 
     * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
     * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
     * @param {string} [positionCode] Narrows to questions assigned this position by its number. Questions meant for every position are not among them; allPositions finds those.
     * @param {string} [locale] Language the full text search runs in, and of the summary where the version has wording in it; otherwise the summary is in the source language. Defaults to pl. A tag of a real language, such as pl or pt-BR: xx has the shape but names no language and is refused.
     * @param {TranslationStatusDto} [translationStatus] Finds questions whose translation into \&quot;locale\&quot; is in this state.
     * @param {string} [author] Who created the question, matched exactly. Stored as the sign-in name rather than an id, because authors come from the identity provider and are not a table here.
     * @param {string} [q] Searches the question key, and the question body and its answers in \&quot;locale\&quot;, by fragment: \&quot;olej\&quot; finds \&quot;oleju\&quot;, \&quot;bhp-1\&quot; finds BHP-12. Polish inflects every ending, and PostgreSQL ships no Polish dictionary, so matching whole words would miss most of what people type. At least three characters: the search index works on three-letter fragments, and anything shorter would read every question in the bank. Leave the parameter out to list without searching.
     * @param {string} [changedFrom] 
     * @param {string} [changedTo] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction, for example \&quot;updatedAt,desc\&quot;. Defaults to newest change first.
     * @param {boolean} [forReview] true for the questions marked for review, false for the rest. Leave it out for both. Listed last on purpose: generated clients pass parameters by position, and one added in the middle would shift every argument after it.
     * @param {string} [procedureName] Narrows to questions citing this procedure: the name exactly as listProcedureNames gives it, letter case aside. Where a review after the procedure changes starts. After forReview for the reason given there.
     * @param {boolean} [allPositions] true for the questions meant for every position, false for those assigned particular ones. Leave it out for both. Last, for the reason given at forReview.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    listQuestions(categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, page?: number, size?: number, sort?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<QuestionPageDto>;

    /**
     * Classification hangs off the question, not off a version, so changing it does not create a new version and does not touch what anyone answered. The business key never changes, even when the question moves to a different category — a key is an identifier, not a label. The sources are replaced as a whole, in the order given.
     * @summary Change category, sources, tags and positions
     * @param {string} questionId 
     * @param {UpdateClassificationRequestDto} updateClassificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    updateQuestionClassification(questionId: string, updateClassificationRequestDto: UpdateClassificationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsDto>;

    /**
     * For a typo or a clarification that does not change the meaning. Translation statuses are left alone, because the translations still say the same thing; a language the correction adds is a DRAFT. The source language stays as it is — wording first written in another language is a new version, so a different sourceLocale is refused with 400. Retired versions cannot be edited: history that can be corrected is not history. Name every answer that stays by its id: an answer left out is removed with its pictures and films, which a version in force refuses with 409.
     * @summary Correct a version in place
     * @param {string} questionId 
     * @param {string} versionId 
     * @param {QuestionVersionContentDto} questionVersionContentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApiInterface
     */
    updateQuestionVersion(questionId: string, versionId: string, questionVersionContentDto: QuestionVersionContentDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionVersionDto>;

}

/**
 * QuestionsApi - object-oriented interface
 * @export
 * @class QuestionsApi
 * @extends {BaseAPI}
 */
export class QuestionsApi extends BaseAPI implements QuestionsApiInterface {
    /**
     * Exactly one version per question is ACTIVE. Activating a version retires the one in force, in the same transaction, so the question is never left without one in between; the database enforces the rule with a partial unique index. The version\'s wording in its source language is approved with it, if it was still a draft: whoever puts a version in force has read it, and a test draws approved wording only. Other languages keep their status. The history records both in one entry.
     * @summary Make a version the one in force
     * @param {string} questionId 
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public activateQuestionVersion(questionId: string, versionId: string, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).activateQuestionVersion(questionId, versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One operation on many questions: add or remove tags, set the category, retire, mark for review or take the mark off. The questions are named by id — those ticked on the page — or by the list\'s filter, which spares sending thousands of ids and cannot drift from what the list showed; exactly one of the two. Start with dryRun: it answers how many questions the operation changes and a few of their keys, and changes nothing — the confirmation screen is built from it. Above 50 changed questions the request has to say confirmLargeChange, or it is refused with 409: a mistaken click must not retire half the bank. Everything happens in one transaction; on any error nothing changes. A question the operation would leave as it is — already tagged, already in the category, already marked, no version in force to retire — is skipped and counted, not refused. Every question changed gets its own entry in its history. Changing classification creates no version.
     * @summary Change many questions at once
     * @param {BulkUpdateRequestDto} bulkUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public bulkUpdateQuestions(bulkUpdateRequestDto: BulkUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).bulkUpdateQuestions(bulkUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The first version is created as a DRAFT. Leave businessKey empty to have one issued from the category prefix and a counter; supply it only when carrying a question over from an existing bank. A key is unique regardless of letter case: with BHP-1 in the bank, bhp-1 is refused with 409.
     * @summary Create a question with its first version
     * @param {CreateQuestionRequestDto} createQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestion(createQuestionRequestDto: CreateQuestionRequestDto, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestion(createQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For a substantive rewrite. The version in force is retired at once — or, with keepCurrent, stays in force until the new one is activated, so that the question does not drop out of tests while the new version is being prepared. Every translation of the new version except the source language starts as MISSING — which is how the list of questions awaiting translation writes itself. The new version takes over the pictures and films of the newest one, and those of every answer it names by id.
     * @summary Create a new version of a question
     * @param {string} questionId 
     * @param {QuestionVersionContentDto} questionVersionContentDto 
     * @param {boolean} [keepCurrent] true keeps the version in force until the new one is activated; false retires it at once. The interface asks every time — a procedure that changed wants the old wording gone now, a better picture does not.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestionVersion(questionId: string, questionVersionContentDto: QuestionVersionContentDto, keepCurrent?: boolean, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestionVersion(questionId, questionVersionContentDto, keepCurrent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the classification and the full history: every version with its status, scoring and translations. Retired versions are included — an attempt from years ago has to be reproducible in the wording the employee actually saw.
     * @summary One question with every version
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestion(questionId: string, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestion(questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Versions newest first, each with its events newest first, and apart from them the changes of the question\'s classification. Answers the question asked at the first dispute about a result: how was this worded when the employee answered, and who has changed it since.
     * @summary What happened to a question, version by version
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionHistory(questionId: string, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionHistory(questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any version, a retired one included, exactly as it was worded while it was in force — an attempt from years ago has to be reproducible in the words the employee read. Comparing two versions is left to the interface: it fetches both in full, because what a difference should show changes more often than this contract.
     * @summary One version in full
     * @param {string} questionId 
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionVersion(questionId: string, versionId: string, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionVersion(questionId, versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Filtering, sorting and paging happen on the server. The bank is designed for tens of thousands of questions, so fetching everything and filtering in the browser is not an option at any size. Each row describes the version in force, or the newest when none is: what employees see. Filters and the text search read that version too; a draft being written next to it shows as draftVersionNo.
     * @summary List questions
     * @param {string} [categoryId] 
     * @param {QuestionTypeDto} [type] 
     * @param {QuestionPurposeDto} [purpose] 
     * @param {VersionStatusDto} [status] 
     * @param {SourceTypeDto} [source] Narrows to questions with a source of this type, whatever other sources they have.
     * @param {Array<string>} [tagId] Repeatable. A question matches when it carries every tag given.
     * @param {string} [positionCode] Narrows to questions assigned this position by its number. Questions meant for every position are not among them; allPositions finds those.
     * @param {string} [locale] Language the full text search runs in, and of the summary where the version has wording in it; otherwise the summary is in the source language. Defaults to pl. A tag of a real language, such as pl or pt-BR: xx has the shape but names no language and is refused.
     * @param {TranslationStatusDto} [translationStatus] Finds questions whose translation into \&quot;locale\&quot; is in this state.
     * @param {string} [author] Who created the question, matched exactly. Stored as the sign-in name rather than an id, because authors come from the identity provider and are not a table here.
     * @param {string} [q] Searches the question key, and the question body and its answers in \&quot;locale\&quot;, by fragment: \&quot;olej\&quot; finds \&quot;oleju\&quot;, \&quot;bhp-1\&quot; finds BHP-12. Polish inflects every ending, and PostgreSQL ships no Polish dictionary, so matching whole words would miss most of what people type. At least three characters: the search index works on three-letter fragments, and anything shorter would read every question in the bank. Leave the parameter out to list without searching.
     * @param {string} [changedFrom] 
     * @param {string} [changedTo] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction, for example \&quot;updatedAt,desc\&quot;. Defaults to newest change first.
     * @param {boolean} [forReview] true for the questions marked for review, false for the rest. Leave it out for both. Listed last on purpose: generated clients pass parameters by position, and one added in the middle would shift every argument after it.
     * @param {string} [procedureName] Narrows to questions citing this procedure: the name exactly as listProcedureNames gives it, letter case aside. Where a review after the procedure changes starts. After forReview for the reason given there.
     * @param {boolean} [allPositions] true for the questions meant for every position, false for those assigned particular ones. Leave it out for both. Last, for the reason given at forReview.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public listQuestions(categoryId?: string, type?: QuestionTypeDto, purpose?: QuestionPurposeDto, status?: VersionStatusDto, source?: SourceTypeDto, tagId?: Array<string>, positionCode?: string, locale?: string, translationStatus?: TranslationStatusDto, author?: string, q?: string, changedFrom?: string, changedTo?: string, page?: number, size?: number, sort?: string, forReview?: boolean, procedureName?: string, allPositions?: boolean, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).listQuestions(categoryId, type, purpose, status, source, tagId, positionCode, locale, translationStatus, author, q, changedFrom, changedTo, page, size, sort, forReview, procedureName, allPositions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Classification hangs off the question, not off a version, so changing it does not create a new version and does not touch what anyone answered. The business key never changes, even when the question moves to a different category — a key is an identifier, not a label. The sources are replaced as a whole, in the order given.
     * @summary Change category, sources, tags and positions
     * @param {string} questionId 
     * @param {UpdateClassificationRequestDto} updateClassificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public updateQuestionClassification(questionId: string, updateClassificationRequestDto: UpdateClassificationRequestDto, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).updateQuestionClassification(questionId, updateClassificationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For a typo or a clarification that does not change the meaning. Translation statuses are left alone, because the translations still say the same thing; a language the correction adds is a DRAFT. The source language stays as it is — wording first written in another language is a new version, so a different sourceLocale is refused with 400. Retired versions cannot be edited: history that can be corrected is not history. Name every answer that stays by its id: an answer left out is removed with its pictures and films, which a version in force refuses with 409.
     * @summary Correct a version in place
     * @param {string} questionId 
     * @param {string} versionId 
     * @param {QuestionVersionContentDto} questionVersionContentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public updateQuestionVersion(questionId: string, versionId: string, questionVersionContentDto: QuestionVersionContentDto, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).updateQuestionVersion(questionId, versionId, questionVersionContentDto, options).then((request) => request(this.axios, this.basePath));
    }
}

